import { SHOPIFY_GRAPHQL_QUERY } from './brands-graphql.js';

async function fetchAllVendors() {
  const token = window.globalData.storefront;
  const shopUrl = window.globalData.shop_url.replace(/^https?:\/\//, '');
  let allVendors = [];
  let cursor = null;
  let hasNextPage = true;

  while (hasNextPage) {
    const response = await fetch(`https://${shopUrl}/api/2024-07/graphql.json`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': token,
      },
      body: JSON.stringify({
        query: SHOPIFY_GRAPHQL_QUERY,
        variables: { cursor },
      }),
    });

    const result = await response.json();

    const products = result?.data?.products?.edges || [];

    products.forEach((edge) => {
      const vendor = edge.node.vendor?.trim();
      if (vendor && !allVendors.includes(vendor)) {
        allVendors.push(vendor);
      }
    });

    hasNextPage = result?.data?.products?.pageInfo?.hasNextPage;
    cursor = result?.data?.products?.pageInfo?.endCursor;
  }

    // Sort alphabetically
  return allVendors.sort((a, b) => a.localeCompare(b));
}

function groupVendorsByLetter(vendors) {
  const grouped = {};
  vendors.forEach((vendor) => {
    const firstLetter = vendor[0].toUpperCase();
    if (!grouped[firstLetter]) grouped[firstLetter] = [];
    grouped[firstLetter].push(vendor);
  });
  return grouped;
}

async function renderVendors() {
  const vendorsContainer = document.getElementById('vendors-list');
  if (!vendorsContainer) return;

  vendorsContainer.innerHTML = '<p>Loading brands...</p>';

  const vendors = await fetchAllVendors();
  if (!vendors || vendors.length === 0) {
    vendorsContainer.innerHTML = '<p>No brands found.</p>';
    return;
  }

  const alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');
  const groupedVendors = groupVendorsByLetter(vendors);

  const alphabetNav = `
    <div id="alphabet-nav" class="alphabet-nav">
      ${alphabet
        .map(
          (letter) => `
          <button class="alphabet-btn" data-letter="${letter}" ${
            groupedVendors[letter] ? '' : 'disabled'
          }>${letter}</button>`
        )
        .join('')}
    </div>
  `;

  const vendorGroups = Object.keys(groupedVendors)
    .map(
      (letter) => `
        <div class="vendor-group" id="group-${letter}">
          <h2 class="vendor-letter">${letter}</h2>
          <ul class="vendor-grid">
            ${groupedVendors[letter]
              .map(
                (vendor) => `
                <li class="vendor-item">
                  <a href="/collections/vendors?q=${encodeURIComponent(vendor)}">${vendor}</a>
                </li>`
              )
              .join('')}
          </ul>
        </div>
      `
    )
    .join('');

  vendorsContainer.innerHTML = alphabetNav + vendorGroups;

  document.querySelectorAll('.alphabet-btn').forEach((btn) => {
    btn.addEventListener('click', () => {
      const letter = btn.dataset.letter;
      const target = document.getElementById(`group-${letter}`);
      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });
}

document.addEventListener('DOMContentLoaded', renderVendors);
